<template>
    <div class="row" :class="{ 
        'moderator': adminMode,
        'client': !adminMode,
        'week-calendar': weekMode,
        'day-calendar': !weekMode,
        }">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <h1>{{ product.name }}</h1>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <button class="btn btn-sm btn-default btn-block" 
                        v-if="admin"
                        @click="openResourceControlsModal()">
                        {{ $_locale('resource controls') }}
                    </button>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <div class="alert alert-info calendar-modifiers" 
                            role="alert" 
                            v-if="admin"
                            style="cursor:pointer;">
                        <!--
                        <div v-if="admin" 
                            class="calendar-modifier-clientmode"
                            @click="toggleAdminMode" role="button">
                            {{ $_locale('client order mode') }}: <span>
                            <b v-if="!adminMode">{{ $_locale('on') }}</b>
                            <b v-if="adminMode">{{ $_locale('off') }}</b>
                            </span>
                        </div>
                        -->
                        <div 
                            class="calendar-modifier-clientmode"
                            @click="toggleOrderMode" 
                            role="button">
                            {{ $_locale('disable times') }}: <span>
                            <b v-if="mode === ORDER_MODES.disable">{{ $_locale('on') }}</b>
                            <b v-else>{{ $_locale('off') }}</b>
                            </span>
                        </div>
                        <!--
                        <div @click="toggleWeekMode" 
                            class="calendar-modifier-viewmode"
                            role="button">
                            {{ $_locale('week view mode') }}: <span>
                                <b v-if="weekMode">{{ $_locale('on') }}</b>
                                <b v-if="!weekMode">{{ $_locale('off') }}</b>
                            </span>
                        </div>
                        -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-3 datepicker-master">
                    <button class="btn btn-xs btn-default" @click="adjustDate(-1)">
                        <i class="glyphicon glyphicon-chevron-left"></i>
                    </button>
                    <input type="text" class="form-control" ref="dateInput" style="margin: 0 7px;" />
                    <button class="btn btn-xs btn-default" @click="adjustDate(1)">
                        <i class="glyphicon glyphicon-chevron-right"></i>
                    </button>
                </div>
                <template v-if="adminMode">
                    <div class="col-xs-12 col-sm-2">
                        <TimeSelector 
                            :min="settings.startTime"
                            :max="settings.endTime"
                            v-model="startTime"
                            @input="onStartTimeChange" />
                        <!--
                        <input type="time" 
                            class="form-control" 
                            v-model="startTime"
                            @change="onStartTimeChange">
                        -->
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <TimeSelector 
                            :min="settings.startTime"
                            :max="settings.endTime"
                            v-model="endTime"
                            :disabled="!adminMode" />
                        <!--
                        <input type="time" 
                            class="form-control" 
                            v-model="endTime" 
                            :disabled="!adminMode">
                        -->
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <div class="form-group" v-if="false">
                            <!-- if this is reinstated, make it use the array -->
                            <select class="form-control">
                                <option v-for="(table, index) in resources" 
                                        :key="index"
                                        :value="table.resourceId">
                                    {{ table.title }}
                                </option>
                            </select>
                        </div>
                        <input type="text" class="form-control"
                            v-if="adminMode"
                            v-model="extraInformation"
                            :placeholder="$_locale(mode === ORDER_MODES.disable ? 'reason' : 'additional info')">
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <button class="btn btn-success btn-block" 
                            v-if="mode === ORDER_MODES.normal"
                            :disabled="!orderValid"
                            @click="saveOrder">
                            {{ $_locale('make a reservation') }}
                        </button>
                        <button class="btn btn-danger btn-block" 
                            v-if="mode === ORDER_MODES.disable"
                            :disabled="!orderValid"
                            @click="disableTimeBlocks">
                            {{ $_locale('disable times') }}
                        </button>
                    </div>
                </template>
            </div>
        </div>
        <div class="col-xs-12">
            <div v-if="!isInvalidDate(date)" 
                class="equipment-reservation-table"
                :class="{
                    'admin-mode': adminMode,
                    'client-mode': !adminMode,
                    'week-mode': weekMode,
                    'day-mode': !weekMode,
                }">
                <div class="basetimetable">
                    <div class="time"
                        v-for="(time, index) in baseTimeTable" :key="index">
                        <span class="title">{{ $_formatDateTime($_dateFormat.DATETIME_HI, time.start) }}</span>
                    </div>
                </div>
                <div class="timetable" :style="`--hours-count: ${ baseTimeTable.length };`">
                    <div class="equipment-resource-titles">
                        <div v-for="(table, index) in timeTableRows"
                            :key="index" 
                            :class="[
                                index % 2 == 0 ? 'even' : 'odd',
                                'resource-title-'+table.resourceId,
                            ]">
                            <template v-if="adminMode">
                                <label class="title" :for="'select-'+table.resourceId">{{ table.title }}</label>
                                <span v-if="availabilityRate.includes(table.resourceId)">
                                    <input type="checkbox" :id="'select-'+table.resourceId"
                                        :checked="selectedResourceIds.includes(table.resourceId)"
                                        @click="toggleResource(table.resourceId)">
                                </span>
                            </template>
                            <template v-else>
                                <span class="title">{{ table.title }}</span>
                            </template>
                        </div>
                    </div>
                    <div class="base" v-if="!disabled">
                        <div v-if="dateChangeInProgress" style="position:absolute;top:0;left:0;left: 60px;width: calc(100% - 60px);height:100%;min-height:450px;z-index: 10;">
                            <div class="spinner-master" style="">
                                <div style="">
                                    <i class="glyphicon glyphicon-refresh spin"></i>
                                </div>
                            </div>
                        </div>
                        <div v-for="(table, index) in timeTableRows"
                            :key="index" 
                            class="resource-row"
                            :class="[
                                index % 2 == 0 ? 'even' : 'odd',
                                'resource-row-'+table.resourceId,
                            ]">
                            <ResourceBlock v-for="reservation in tableReservations(table)"
                                :key="reservation.reservationTimeId"
                                :reservation="reservation" />
                            <ResourceBlock class="ghost"
                                v-if="ghostAvailable(table.resourceId)"
                                :reservation="ghostReservation(table.resourceId)" />
                            <ResourceBlock class="ghost disabled-resource"
                                v-if="isDisabledResource(table.resourceId)"
                                :reservation="disabledResource(table.resourceId)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <EditReservationModal v-if="admin" />
        <ResourceControlsModal v-if="admin" />
    </div>
</template>

<script>
import ResourceBlock from './ResourceBlock.vue';
import TimeSelector from './TimeSelector.vue';
import ResourceControlsModal from './ResourceControlsModal.vue';
import EditReservationModal from '../CalendarReservation/EditReservationModal.vue';
import CreateReservationMixin from '../common/CreateReservationMixin.js'
import { getDuration, TIMEBLOCK_TYPE } from '../common/ReservationService.js';

import { mapGetters } from 'vuex'
const { formatDateTime, dateFormat, getDateFormat } = window.wisenetwork;
const ORDER_MODES = {
    normal: 1,
    disable: 2,
}

export default {
    components: {
        ResourceBlock,
        TimeSelector,
        EditReservationModal,
        ResourceControlsModal,
    },
    mixins: [ CreateReservationMixin ],
    data: () => ({
        ORDER_MODES,
        mode: ORDER_MODES.normal,
        extraInformation: '',
        selectedResourceIds: [],
        selectedWeekday: 0,
        startTime: '08:00',
        endTime: '10:00',
        pendingResourceChange: false,
    }),
    computed: {
        ...mapGetters({
            date: 'reservations/date',
            dateChangeInProgress: 'reservations/dateChangeInProgress',
            weekMode: 'reservations/weekMode',
            isInvalidDate: 'reservations/isInvalidDate',
            settings: 'reservations/settings',
            availabilityRate: 'reservations/availabilityRate',
            disabledResources: 'reservations/disabledResources',
            selectedViewMode: 'calendar/selectedViewMode',
            VIEW_MODES: 'calendar/VIEW_MODES',
            timeTable: 'calendar/timeTable',
            baseTimeTable: 'calendar/baseTimeTable',
            product: 'ecom/product',
            admin: 'common/admin',
            adminMode: 'common/adminMode',
            mobile: 'common/mobile',
            disabled: 'reservations/disabled',
            dateRestrictions: 'reservations/dateRestrictions'
        }),
        timeTableRows() {
            return this.timeTable;
        },
        tableReservations() {
            const adminMode = this.adminMode;
            const date = this.date;
            const { startTime } = this.settings;
            const dateTimeStart = `${ date.format('YYYY-MM-DD') } ${ startTime }`
            const mapReservations = (reservation) => {
                const { 
                    start, 
                    end, 
                    isCart = false, 
                    firstName = '', 
                    lastName = '', 
                    company = '',
                    extraInformation = '',
                    overrideName = '',
                } = reservation;
                
                const fromStart = getDuration(moment(start), moment(dateTimeStart), false);
                const length = getDuration(moment(start), moment(end));
                // generated block that other calendar types use
                // and methods assume elsewhere
                const block = {
                    type: TIMEBLOCK_TYPE.reservation,
                }

                if (adminMode) {                    
                    let status = isCart ? this.$_locale('in cart') : this.$_locale('reserved');
                    let reservedName = `${ lastName } ${ firstName[0] }.`;

                    if (typeof company === 'string' && company.length > 0) {
                        reservedName = `${ company } (${ reservedName })`
                    }
                    
                    if (overrideName) {
                        // EcomReservation extra json -> overrideName
                        block.info = `${ status }: ${ overrideName }`
                        // for reservation editor modal
                        block.overrideName = overrideName
                    } else if (extraInformation) {
                        // extraInformation from EcomOrder
                        block.info = `${ status }: ${ extraInformation }`
                    } else {
                        block.info = `${ status }: ${ reservedName }`
                    }                    
                }

                if (reservation.status === 4) {
                    block.type = TIMEBLOCK_TYPE.disabled;
                    block.info = `${ _locale('time disabled').ucfirst() }: ${ lastName } ${ firstName }`; 
                    block.disabled = true;
                    block.disableReason = `${ extraInformation || '' }`;
                } else {
                    if (isCart) {
                        block.type = TIMEBLOCK_TYPE.reservationInCart
                    }

                    if (reservation.orderId && reservation.orderStatusId != 2) {
                        const totalPaid = -(-reservation.totalPaid); // number parse hack

                        if (totalPaid > 0) {
                            block.partlyPaid = true;
                        } else {
                            block.paymentDelayed = true;
                        }
                    }

                    if (reservation.isUserReservation) {
                        block.isUserReservation = true;
                    }
                }

                return {
                    ...reservation,
                    fromStart,
                    length,
                    steps: fromStart / 10,
                    lengthSteps: length / 10,
                    block,
                }
            }

            return (table) => table.reservations
                .map(mapReservations)
                .sort((a, b) => {
                    return b.length > a.length ? 1 : -1;
                })
        },
        resources() {
            const timeTable = this.timeTable;

            return timeTable.map(row => {
                const { resourceId, title, reservations } = row;

                return {
                    resourceId,
                    title,
                    reservations,
                }
            })
        },
        resourceSelectorVisible() {
            if (this.weekMode) return true;
            if (!this.mobile) return false;
            if (this.timeTable.length === 1) return false;

            return true;
        },
        weekdaySelectorVisibile() {
            if (!this.mobile) return false;
            if (!this.weekMode) return false;

            return true;
        },
        maxStartTime() {
            const { minDuration } = this.settings;
            const maxEndTime = this.maxEndTime;
            const lastCall = maxEndTime.subtract(minDuration, 'minutes')

            return lastCall;
        },
        maxEndTime() {
            const date = this.date;
            const { endTime } = this.settings;
            return moment(
                `${ date.format('YYYY-MM-DD') } ${ endTime }`
            )
        },
        dateTimeStart() {
            if (!this.startTime) return null;

            const date = this.date;

            return `${ date.format('YYYY-MM-DD') } ${ this.startTime }`
        },
        dateTimeEnd() {
            if (!this.endTime) return null;

            const date = this.date;

            return `${ date.format('YYYY-MM-DD') } ${ this.endTime }`
        },
        disabledResource() {
            return (resourceId) => {
                if (this.disabledResources.includes(resourceId) === false) return null;

                const date = this.date;
                const { startTime, endTime, reservationId } = this.settings;
                const start = moment(`${ date.format('YYYY-MM-DD') } ${ startTime }`)
                const end = moment(`${ date.format('YYYY-MM-DD') } ${ endTime }`)
                const fromStart = 0;
                const length = getDuration(start, end);

                return {
                    isPlaceholder: true,
                    reservationId,
                    resourceId,
                    start,
                    end,
                    fromStart,
                    length,
                    steps: fromStart / 10,
                    lengthSteps: length / 10,
                    block: {}
                }
            }
        },
        ghostReservation() {
            return (resourceId) => {
                if (this.selectedResourceIds.includes(resourceId) === false) return null;
                if (!this.dateTimeStart) return null;
                if (!this.dateTimeEnd) return null;

                const date = this.date;
                const { startTime, reservationId } = this.settings;
                const fromStart = getDuration(
                    moment(this.dateTimeStart), 
                    `${ date.format('YYYY-MM-DD') } ${ startTime }`,
                    false
                );
                const length = getDuration(
                    moment(this.dateTimeStart), 
                    moment(this.dateTimeEnd)
                );

                return {
                    isPlaceholder: true,
                    reservationId,
                    resourceId,
                    start: this.dateTimeStart,
                    end: this.dateTimeEnd,
                    fromStart,
                    length,
                    steps: fromStart / 10,
                    lengthSteps: length / 10,
                    block: {}
                }
            }
        },
        isDisabledResource() {
            const adminMode = this.adminMode;

            return (resourceId) => {

                return adminMode && this.disabledResources.includes(resourceId);
            }
        },
        ghostAvailable() {
            const adminMode = this.adminMode;

            return (resourceId) => {
                const ghostReservation = this.ghostReservation(resourceId);

                return adminMode 
                    && ghostReservation !== null
                    && this.selectedResourceIds.includes(resourceId);
            }
        },
        orderValid() {
            return this.adminMode && this.selectedResourceIds.length > 0;
        },
    },
    watch: {
        availabilityRate: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                const [ newResourceId ] = newVal;
                const [ selectedResourceId ] = this.selectedResourceIds;
                let oldResourceId = null;
                
                if (Array.isArray(oldVal)) {
                    oldResourceId = oldVal[0];
                }
                
                if (newResourceId === oldResourceId
                    && selectedResourceId === newResourceId) {
                    return;
                }
                
                if (this.pendingResourceChange) {
                    this.selectedResourceIds = [ newResourceId ];
                    this.pendingResourceChange = false;
                    this.setDefaultStartTime();
                }
            }
        },
    },
    methods: {
        setDefaultStartTime() {
            const now = moment()
            const next10thMinute = now.startOf('minute').add(
                10 - (now.minute() % 10), 
                'minutes'
            )

            this.startTime = next10thMinute.format('HH:mm')
            this.onStartTimeChange({
                target: {
                    value: next10thMinute.format('HH:mm')
                }
            })
        },
        onStartTimeChange() {
            const date = this.date;
            const maxEndTime = this.maxEndTime;
            const { minDuration, endTime } = this.settings;
            const newEndTime = moment(
                `${ date.format('YYYY-MM-DD') } ${ this.startTime }`
            ).add(minDuration, 'minutes');
            // we went too far
            if (newEndTime > maxEndTime) {
                this.endTime = endTime;
                return;
            }
            
            this.endTime = newEndTime.format('HH:mm')
        },
        toggleAdminMode() {
            this.$store.commit('common/toggleAdminMode')
            this.$store.commit('reservations/setServiceAdminMode', this.adminMode);
            
            this.$store.dispatch('reservations/onDateChange', this.date)
                .then(() => {
                    this.$emit('adminToggle')
                })
        },
        toggleWeekMode() {
            this.$store.commit('reservations/toggleWeekMode')
            this.$store.dispatch('reservations/onWeekModeChange')
        },
        toggleOrderMode() {
            const mode = this.mode;

            if (mode === ORDER_MODES.normal) {
                const { startTime, endTime } = this.settings;

                this.mode = ORDER_MODES.disable;
                // settings time format is HH:mm:ss when we need HH:mm
                this.startTime = startTime.substr(0,5);
                this.endTime = endTime.substr(0,5);
            } else {
                this.mode = ORDER_MODES.normal;
                this.setDefaultStartTime()
            }
        },
        adjustDate(value) {
            const input = this.$refs.dateInput;
            const picker = input._daterangepicker
            const date = this.date.clone().add(value, this.weekMode ? 'weeks' : 'days');
            
            if (picker) {
                picker.setStartDate(date);
                picker.setEndDate(date);
            } else {
                console.warn('daterangepicker not initialized')
            }
            
            this.pendingResourceChange = true;
            this.$store.dispatch('reservations/onDateChange', date);
        },
        initDatepicker() {
            const { daterangepicker } = window.wisenetwork
            const input = this.$refs.dateInput;
            const dayNameShort = getDateFormat(dateFormat.DATETIME_DAY_NAME_SHORT);
            const dayFormat = getDateFormat(dateFormat.DATETIME_DMY);
            const format = this.weekMode ? `[${ _locale('week').ucfirst() }] w` : dayNameShort+' '+dayFormat;
            const startDate = this.$store.getters['reservations/startDate'];
            
            let date = this.date;
            
            if (startDate > date) {
                date = startDate;
            }

            if (this.mobile) {
                input.readOnly = true;
            }
            
            const picker = daterangepicker(
                input,
                {
                    locale: { 
                        format,
                        daysOfWeek: _localeDates.dayNamesMin,
                        monthNames: _localeDates.monthNamesShort,
                        firstDay: 1,
                    },
                    opens: 'right',
                    showWeekNumbers: true,
                    singleDatePicker: true,
                    showDropdowns: true,
                    startDate: date,
                    isInvalidDate: (date) => this.isInvalidDate(date)
                }, 
                (startDate, endDate) => {
                    this.$store.dispatch('reservations/onDateChange', startDate)
                }
            )

            if (moment().format('YYYY-MM-DD') !== date.format('YYYY-MM-DD')) {
                const toggleFocus = (pulse) => {
                    if (pulse <= 0) return;

                    if (input.classList.contains('input-focus')) {
                        input.classList.remove('input-focus')
                    } else {
                        input.classList.add('input-focus')
                    }

                    setTimeout(() => toggleFocus(pulse - 1), 600)
                }

                setTimeout(() => toggleFocus(6), 600)
            }
        },
        toggleResource(resourceId) {
            const ids = this.selectedResourceIds;

            if (ids.includes(resourceId)) {
                const index = ids.indexOf(resourceId)

                ids.splice(index, 1)
            } else {
                ids.push(resourceId)
            }
        },
        createOrderRows() {
            const selectedResourceIds = this.selectedResourceIds;

            return selectedResourceIds.map(resourceId => {
                const { reservationId, start, end, length } = this.ghostReservation(resourceId);
                const [ resource ] = this.settings.resources.filter(row => row.resourceId === resourceId)
                const productRow = {
                    productId: this.product.productId,
                    productVariantId: 0,
                    quantity: 1,
                    reservation: {
                        reservationId,
                        start: moment(start).format('YYYY-MM-DD HH:mm:ss'),
                        end: moment(end).format('YYYY-MM-DD HH:mm:ss'),
                        duration: length,
                        quantity: 1,
                        resources: [ resource ],
                        title: resource.title,
                        recurringReservation: false,
                    }
                }
                
                return productRow
            })
        },
        saveOrder() {
            if (this.orderValid === false) return false;

            this.pendingResourceChange = true;
            
            const extraInformation = this.extraInformation;
            const data = {
                products: this.createOrderRows(),
                extraInformation,
            }
            
            let gotoCheckout = true;
                        
            if (this.adminMode) {
                data.forClient = true;

                return this.$_swal({
                    title: _locale('Proceed to checkout').ucfirst() + '?',
                    showCancelButton: true,
                    showDenyButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: _locale('Proceed to checkout').ucfirst(),
                    denyButtonText: _locale('add to cart').ucfirst(),
                    cancelButtonText: _locale('save order').ucfirst(),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.addToCart(data);
                    } else if (result.isDenied) {
                        this.addToCart(data, false);
                    } else {
                        data.forceMockOrder = true;
                        this.createMockReservation(data);
                    }
                })
            } else if (this.$refs.priceSummary.getTotalPrice() === 0) {
                gotoCheckout = false;
            }
            
            if (gotoCheckout) {
                this.addToCart(data);
            } else {
                this.createMockReservation(data);
            }
        },
        disableTimeBlocks() {
            if (!this.orderValid) {
                return;
            }
            
            this.pendingResourceChange = true;

            const extraInformation = this.extraInformation;
            const data = {
                forClient: true,
                products: this.createOrderRows(),
                extraInformation,
            };
            
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$store.commit('common/setModal', null)
            
            EcomService.disableTime(data)
            .then((response) => {
                const data = response.data;

                if (data.success) {
                    this.$store.dispatch('reservations/onDateChange', this.date);
                    this.$_swal({ icon: 'success', title: _locale('time disabled').ucfirst() })
                } else {
                    this.$_swal({ icon: 'error', html: data.errors.map((err) => `<p>${ _locale(err.message).ucfirst() }</p>`).join('') })
                }
            })
        },
        openResourceControlsModal() {
            this.$store.commit('common/setModal', 'resourcecontrols')
        },
    },
    mounted() {        
        this.$nextTick(() => {
            this.initDatepicker()

            const resources = [ ...this.resources ].sort(
                (a, b) => {
                    if (a.freeBlocks === b.freeBlocks) {
                        return a.resourceId > b.resourceId ? 1 : -1;
                    }

                    return a.freeBlocks < b.freeBlocks ? 1 : -1;
                }
            )
            
            if (Array.isArray(this.availabilityRate)) {
                const [ selectedResourceId ] = this.availabilityRate;
                
                this.selectedResourceIds = [ selectedResourceId ]
            } else {
                this.selectedResourceIds = [ resources[0].resourceId ]
            }
            
            this.selectedWeekday = moment().day();
            this.setDefaultStartTime();
            /*
            if (moment().format('H') > 12) {
                document.querySelector('.equipment-reservation-table').scrollLeft = 9999;
            }
            */
            if (window.innerWidth < 768) {
                const { startTime } = this.settings;
                const dateTimeStart = `${ moment().format('YYYY-MM-DD') } ${ startTime }`
                const fromStart = getDuration(moment().startOf('hour'), moment(dateTimeStart), false);

                document.querySelector('.equipment-reservation-table').scrollLeft =  fromStart;
            } else if (moment().format('H') >= 12) {
                document.querySelector('.equipment-reservation-table').scrollLeft =  999;
            }   
            // user is admin but adminMode has been set false in another product
            // in this type of product, there is no toggle for adminMode
            if (this.admin && !this.adminMode) {
                this.toggleAdminMode();
            }
        })
    }
}
</script>

<style>
.equipment-reservation-table {
    --time-base-pixel: 10px;
    --time-base-hour: 60px;
    --row-height: 40px;
    --timetable-safe-left: 100px;
    --hours-count: 1;
    margin-bottom: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
    overflow-x: auto;
    position: relative;
}

.equipment-reservation-table .timetable {
    width: calc(var(--time-base-hour) * var(--hours-count));
    display: flex;
}

.equipment-reservation-table .base {
    flex-grow: 1;
}

.equipment-reservation-table .resource-row {
    position: relative;
    height: var(--row-height);
    width: calc(100% + var(--timetable-safe-left));
}

.equipment-reservation-table .resource-row .reservation-block {
    position: absolute;
    height: 24px;
    top: 8px;
    left: 0;
    background: rgb(12, 177, 86);
    color: white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .25), 0 2px 3px rgba(0, 0, 0, .45);
}

.equipment-reservation-table .resource-row .reservation-block.ghost {
    background: rgba(109, 109, 255, .8);
    backdrop-filter: blur(1px);
}

.equipment-reservation-table .resource-row .reservation-block.ghost.disabled-resource {
    background: rgba(228, 228, 228, 0.8);
    color: #222;
}

.equipment-reservation-table .resource-row .reservation-block.reserved-isuserreservation {
    background-color: #17a2b8;
}

.equipment-reservation-table .resource-row .reservation-block.disabled,
.equipment-reservation-table .resource-row .reservation-block.reserved-paymentdelayed {
    background-color: #dc3545;
}

.equipment-reservation-table .resource-row .reservation-block.reserved-cart {
    background-color: #087e91;
}

.equipment-reservation-table .resource-row .reservation-block.reserved-partlypaid {
    background-color: #6017ba;
}

.equipment-reservation-table .basetimetable {
    display: inline-flex;
    gap: 0px;
    flex-wrap: nowrap;
    padding-left: var(--timetable-safe-left);
    position: absolute;
    top: 20px;
    left: 0;
    height: calc(100% - 20px);
}

.equipment-reservation-table .basetimetable .time {
    width: var(--time-base-hour);
    border-left: 1px solid #666;
    padding: 0 7px;
}

.equipment-reservation-table .equipment-resource-titles {
    position: sticky;
    left: 0;
    top: 0;
    width: var(--timetable-safe-left);
    background: rgba(255,255,255,.85);
    z-index: 1;
}

.equipment-reservation-table .equipment-resource-titles > div {
    height: var(--row-height);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 7px 0 5px;
    flex-direction: row;
    gap: 10px;
}

.equipment-reservation-table .equipment-resource-titles label {
    flex-grow: 1;
    user-select: none;
}

.equipment-reservation-table .resource-row.odd,
.equipment-reservation-table .equipment-resource-titles > .odd {
    background: rgba(243, 243, 243, .8);
}

.equipment-reservation-table .resource-row.even,
.equipment-reservation-table .equipment-resource-titles > .even {
    background: rgba(255, 255, 255, .8);
}
.input-focus {
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
}
</style>